export default __webpack_public_path__ + "static/media/saveSend.fdea0e4b.svg";